export enum PaymentCardTypeEnum {
	Pcard = 1,
	VirtualCard = 2,
	CreditCard = 3,
}
